// extracted by mini-css-extract-plugin
export var chevronIcon = "_6l-2";
export var teamName = "_6l-1";
export var teamSwitcherButton = "_6l-0";